import { GridOptions } from "@ag-grid-community/core";
import { OrderStatusCellRendererComponent } from "src/app/ag-grid-components/order-status-cell-renderer/order-status-cell-renderer.component";
import { BooleanCellRendererComponent } from "src/app/ag-grid-components/boolean-cell-renderer/boolean-cell-renderer.component";
import { BuyBoxCellRendererComponent } from "src/app/ag-grid-components/buy-box-cell-renderer/buy-box-cell-renderer.component";
import { ChannelsCellRendererComponent } from "src/app/ag-grid-components/channels-cell-renderer/channels-cell-renderer.component";
import { CheckboxCellRendererComponent } from "src/app/ag-grid-components/checkbox-cell-renderer/checkbox-cell-renderer.component";
import { DateCellRendererComponent } from "src/app/ag-grid-components/date-cell-renderer/date-cell-renderer.component";
import { LinkCellRendererComponent } from "src/app/ag-grid-components/link-cell-renderer/link-cell-renderer.component";
import { AccountCellRendererComponent } from "../../../ag-grid-components/account-cell-renderer/account-cell-renderer.component";
import { SkuCellRendererComponent } from "./../../../ag-grid-components/sku-cell-renderer/sku-cell-renderer.component";
import { ActionsComponent } from "../../../components/actions/actions.component";
import { RankCellRendererComponent } from "src/app/ag-grid-components/rank-cell-renderer/rank-cell-renderer.component";
import { ProductPriceCellRendererComponent } from "src/app/ag-grid-components/product-price-cell-renderer/product-price-cell-renderer.component";
import { OrderInfoCellRendererComponent } from "src/app/ag-grid-components/order-info-cell-renderer/order-info-cell-renderer.component";

export const listingColumnDefs: any = [
  {
    field: "Sku",
    backendFields: [
      "Image",
      "Sku",
      "Asin",
      "Title",
      "AccountType",
      "FulfillmentType",
    ],
    headerName: "Sku",
    sortable: true,
    minWidth: 450,
    cellRenderer: "skuCellRendererComponent",
    filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "SKU",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "ASIN",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
          {
            display: "accordion",
            title: "Title",
            filter: "agTextColumnFilter",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
        ],
      },
  },
  {
    field: "Qty",
    headerName: "Mapped Qty",
    backendFields: ["Qty"],
    width: 110,
    filter: "agNumberColumnFilter",
    valueGetter: (params) => {
      return (Number(params.data.Qty) || 0).toLocaleString('en');
    },
  },
  {
    field: "Channels",
    cellRenderer: "accountCellRendererComponent",
    backendFields: ["Channels",'Account','AccountType'],
    width: 140,
  },
  {
    field: "FulfilmentType",
    headerName: "Fulfilments",
    backendFields: ["FulfilmentType"],
    width: 100,
  },
  {
    field: "Buybox",
    headerName: "BuyBox",
    width: 140,
    sortable: true,
    cellRenderer: "buyBoxCellRendererComponent",
  },
  {
    field: "Price",
    width: 100,
    sortable: true,
    valueFormatter: (param) =>
      param.value ? "$" + (parseFloat(Number(param.value).toFixed(2))).toLocaleString('en') : '$0.00',
    filter: "agNumberColumnFilter"
  },
  {
    field: "AvailableFbastock",
    headerName: "Available Stock",
    cellRenderer: "productPriceCellRendererComponent",
    width: 120,
    filter: "agNumbercolumnFilter",
    valueGetter: (params) => {
      return (Number(params.data.AvailableFbastock) || 0).toLocaleString('en');
    },
  },
  {
    field: "TotalFbastock",
    headerName: "Total Stock",
    backendFields:['TotalFbastock'],
    width: 110,
    sortable: true,
    filter: "agNumberColumnFilter",
    valueGetter: (params) => {
      return (Number(params.data.TotalFbastock) || 0).toLocaleString('en');
    },
  },
  {
    field: "Rank",
    width: 150,
    headerName:"Category/Rank",
    backendFields: ["Rank", "Category"],
    cellRenderer: "rankCellRendererComponent",
  },
  {
    field: "Cost",
    filter: "agNumberColumnFilter",
    headerName: "Avg Cost",
    valueFormatter: (param) =>
          param.value ? "$" + (parseFloat(Number(param.value).toFixed(2))).toLocaleString('en') : '$0.00',
  },
  {
    field: "TotalValue",
    headerName: "Total Value",
    filter: "agNumberColumnbFilter",
    valueFormatter: (param) =>
          param.value ? "$" + param.value.toFixed(2) : '$0.00',
  }
];

export const vendorListingColumnDefs: any = [
  {
    field: "Sku",
    backendFields: [
      "Image",
      "Sku",
      "Asin",
      "Title",
      "AccountType",
      "FulfillmentType",
    ],
    headerName: "Sku",
    sortable: true,
    minWidth: 350,
    cellRenderer: "skuCellRendererComponent",
    filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "SKU",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "ASIN",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
          {
            display: "accordion",
            title: "Title",
            filter: "agTextColumnFilter",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
        ],
      },
  },
  {
    field: "Qty",
    headerName: "Mapped Qty",
    backendFields: ["Qty","Active"],
    width: 110,
    filter: "agNumberColumnFilter"
  },
  {
    field: "Channels",
    cellRenderer: "accountCellRendererComponent",
    backendFields: ["Channels",'Account','AccountType'],
    width: 140,
  },
  {
    field: "FulfillmentType",
    headerName: "Fulfilments",
    backendFields: ["FulfillmentType"],
    width: 100,
    filter: "agSetColumnFilter",
      filterParams: {
        values: ["FBA", "FBM"],
      },
  },
  {
    field: "FbaBBPrice",
    backendFields: [
      "BBAIsYours",
      "FbaBBPrice",
      "BBIsAmazon",
      "BBMIsYour",
      "FbmBBPrice",
      "Minpr",
    ],
    headerName: "BuyBox",
    headerTooltip: 'BuyBox',
    width: 160,
    minWidth: 50,
    sortable: true,
    cellRenderer: "buyBoxCellRendererComponent",
    cellEditor: "buyBoxCellEditorComponent",
    cellEditorParams: {
      priceProp: 'Minpr'
    },
    editable: () => true,
    filter: "agMultiColumnFilter",
    filterParams: {
      defaultOption: "inRange",
      maxNumConditions : 1,
      filters: [
        {
          filter: "agSetColumnFilter",
          display: "accordion",
          title: "BB Offer Type",
          filterParams: {
            values: ["FBA", "FBM", "Amazon"],
          },
        },
        {
          filter: "booleanFilterComponent",
          display: "accordion",
          title: "FBA BB Is Yours",
        },
        {
          filter: "booleanFilterComponent",
          display: "accordion",
          title: "FBM BB Is Yours",
        },
        {
          display: "accordion",
          title: "FBA BB Price",
          filter: "agNumberColumnFilter",
        },
        {
          filter: "agNumberColumnFilter",
          display: "accordion",
          title: "FBM BB Price",
        },
      ],
    },
  },
  {
    field: "Price",
    backendFields:['Price'],
    headerName:'Price',
    width: 100,
    sortable: true,
    valueFormatter: (param) =>
          param.value ? "$" + param.value.toFixed(2) : '$0.00',
    filter: "agNumberColumnFilter"
  },
  {
    field: "Qty",
    backendFields:['Qty'],
    headerName: "Available Stock",
    width: 120,
    filter: "agNumberColumnFilter"
  },
  {
    field: "TotalFbastock",
    headerName: "Total Stock",
    backendFields:['TotalFbastock'],
    width: 110,
    sortable: true,
    filter: "agNumberColumnFilter",
  },
   {
        field: "Rank",
        headerName:"Category/Rank",
        headerTooltip:"Category/Rank",
        backendFields: ["Rank", "Category"],
        sortable: true,
        cellRenderer: "rankCellRendererComponent",
        filter: "agMultiColumnFilter",
        filterParams: {
          filters: [
            {
              filter: "agTextColumnFilter",
              display: "accordion",
              title: "Category",
            },
            {
              filter: "agNumberColumnFilter",
              display: "accordion",
              title: "Rank",
              filterParams: {
                defaultOption: "inRange",
                maxNumConditions : 1,
                filterOptions: [
                  "equals",
                  "notEqual",
                  "lessThan",
                  "lessThanOrEqual",
                  "greaterThan",
                  "greaterThanOrEqual",
                  {
                    displayKey: "inRange",
                    displayName: "Between",
                    test: {},
                  },
                ],
              },
            },
          ],
        },
   },
  {
    field: "Cost",
    filter: "agNumberColumnFilter",
    headerName: "Avg Cost",
    valueFormatter: (param) =>
          param.value ? "$" + param.value.toFixed(2) : '$0.00',
  },
  {
    field: "TotalValue",
    headerName: "Total Value",
    filter: "agNumberColumnFilter",
    valueFormatter: (param) =>
          param.value ? "$" + (parseFloat(Number(param.value).toFixed(2))).toLocaleString('en') : '$0.00',
  }
];

export const listingGridOptions: GridOptions = {
  rowModelType: "serverSide",
  suppressServerSideInfiniteScroll: false,
  suppressCopyRowsToClipboard: true,
  components: {
    booleanCellRendererComponent: BooleanCellRendererComponent,
    buyBoxCellRendererComponent: BuyBoxCellRendererComponent,
    channelsCellRendererComponent: ChannelsCellRendererComponent,
    actionsComponent: ActionsComponent,
    accountCellRendererComponent: AccountCellRendererComponent,
    skuCellRendererComponent: SkuCellRendererComponent,
    orderInfoCellRendererComponent: OrderInfoCellRendererComponent,
    orderStatusCellRendererComponent: OrderStatusCellRendererComponent,
    checkboxCellRendererComponent: CheckboxCellRendererComponent,
    dateCellRendererComponent: DateCellRendererComponent,
    linkCellRendererComponent: LinkCellRendererComponent,
    rankCellRendererComponent: RankCellRendererComponent,
    productPriceCellRendererComponent: ProductPriceCellRendererComponent,
  },
  defaultColDef: {
    resizable: true,
    sortable:false,
    filterParams: {
      maxNumConditions : 1,
    },
    menuTabs: ["filterMenuTab"],
  },
  suppressMenuHide: true,
  icons:{
    menu: '<span class="ag-icon ag-icon-filter" unselectable="on" role="presentation"></span>',
    filter:
      '<span class="ag-icon ag-icon-filter" style="display:none;" unselectable="on" role="presentation"></span>',
  }
};
// export const listingGridOptions: GridOptions = {
//   rowModelType: "serverSide",
//   suppressServerSideInfiniteScroll: false,
//   suppressCopyRowsToClipboard: true,
//   defaultColDef: {
//     resizable: true,
//     filterParams: {
//       maxNumConditions : 1,
//     },
//     menuTabs: ["filterMenuTab"],
//   },
// };
